const LegendaryHeroes_Surfer = [
  { name: "surfer1", url: require("./jfhLegendary_013.jpg") },
  { name: "surfer2", url: require("./jfhLegendary_014.jpg") },
  { name: "surfer3", url: require("./jfhLegendary_015.jpg") },
  { name: "surfer4", url: require("./jfhLegendary_016.jpg") },
];
export default LegendaryHeroes_Surfer;
